import { useMemo } from 'react';
import WebMercatorViewport from '@math.gl/web-mercator';

const getBounds = (markers) => {
    const markersLongitude = markers.map((marker) => marker.longitude);
    const markersLatitude = markers.map((marker) => marker.latitude);

    const bottomLeftBound = [
        Math.min(...markersLongitude),
        Math.min(...markersLatitude),
    ];
    const topRightBound = [
        Math.max(...markersLongitude),
        Math.max(...markersLatitude),
    ];
    const bounds = [bottomLeftBound, topRightBound];

    return bounds;
};

const useMap = ({ height, width, markers }) => {
    let initialViewState = {
        height: height,
        width: width,
        zoom: 7,
        bearing: 0,
        pitch: 0,
    };

    if (height && width && markers) {
        const bounds = useMemo(() => getBounds(markers), [markers]);
        initialViewState = new WebMercatorViewport({
            height,
            width,
        }).fitBounds(bounds, { padding: 100 });
    }

    return {
        initialViewState,
    };
};

export default useMap;
